import React from 'react';
import classnames from 'classnames';
import { useDelayedHover } from '@instinet-analytics/core-lib';
import Tooltip, { TooltipText } from 'utils/components/Tooltip/Tooltip';
import { useXAxisContext } from 'utils/components/TimeSeriesChart/XAxisContext';
import styleConstants from '../variables.module.scss';
import './YAxisLabel.scss';

const PADDING = parseInt(styleConstants.labelPadding);
const LABEL_HEIGHT = parseInt(styleConstants.labelRectHeight);

export interface YAxisLabelProps {
    type: string;
    value: string;
    top: number;
    chartWidth: number;
    tooltip: TooltipText;
    onClick?: () => void;
}

export default function YAxisLabel({
    type,
    value,
    top,
    chartWidth,
    tooltip,
    onClick,
}: YAxisLabelProps) {
    const { plotAreaWidth } = useXAxisContext();
    const [onMouseEnter, onMouseLeave, showTypeLabel] = useDelayedHover(500);
    return (
        <div
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            className="YAxisLabel"
            style={{
                top: top + LABEL_HEIGHT,
                left: plotAreaWidth + PADDING,
            }}
        >
            <div>
                <Tooltip text={tooltip}>
                    {showTypeLabel && (
                        <div
                            className={classnames(
                                'label-section',
                                type,
                                'label'
                            )}
                            style={{
                                top: -LABEL_HEIGHT,
                                right: 0,
                            }}
                        >
                            {type}
                        </div>
                    )}
                    <div
                        className={classnames(
                            'label-section',
                            type,
                            'value',
                            showTypeLabel && 'withLabel'
                        )}
                        style={{
                            top: -LABEL_HEIGHT,
                            maxWidth: chartWidth - plotAreaWidth - PADDING,
                        }}
                    >
                        {value}
                    </div>
                </Tooltip>
            </div>
        </div>
    );
}
